import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { isNumeric } from '../../utils/Numeric';
import {
  message, Modal,
  Affix,
  Checkbox, Select, Button, Tabs
} from 'antd';
import moment from 'moment';
import {
  UploadOutlined,
  ExclamationCircleOutlined,
  CheckCircleTwoTone,
  DiffOutlined,
  SyncOutlined,
  PlusCircleFilled,
  PlusCircleOutlined
} from '@ant-design/icons';
import { getGoodsBySpecName } from '../../services/Goods';
import {
  getList,
  insertGoods,
  insertGoodsPrice,
  updatePackageSize,
  getGoodsAndPriceList
} from '../../services/Buyer';

import { getDatetime } from '../../services/Login';
export default React.forwardRef((props, ref) => {
  const { onCloseCallback, buyer, reload } = props;
  const columns = ['#', '产品号', 'PCS/CTN', 'CTNS/PLT', '价格']
  const [fileName, setFileName] = useState('');
  const [rows, setRows] = useState([]);
  const [datetime, setDatetime] = useState(undefined);
  const [goodsList, setGoodsList] = useState([]);
  const [isChecking, setChecking] = useState(false);
  const [isSyncing, setSyncing] = useState(false);
  const [buyerName, setBuyerName] = useState(undefined);

  useEffect(() => {
    getDatetime().then(data => setDatetime(data));
    getGoodsAndPriceList(buyer.id).then(data => setGoodsList(data));
  }, [])

  const syncSupplierDB = async () => {
    setSyncing(true);
    const key = 'update_goods';
    const temp = [].concat(rows);
    const arr = [];
    const arr1 = [];
    if (temp.length > 0) {
      const insertArr = rows.filter(x => x.status === 2);
      if (insertArr.length > 0) {
        arr.push(new Promise((resolve, reject) => {
          insertGoods(buyer.id, insertArr).then(data => {
            resolve(true);
          });
        }));

        insertArr.forEach(x => {
          arr1.push(new Promise((resolve, reject) => {
            insertGoodsPrice(buyer.id, x._goods_id, x._goods_spec_id, x).then(data => {
              x.status = 0;
              resolve(true);
            })
          }))
        })
      }
      const updateArr = rows.filter(x => x.status === 3);
      updateArr.forEach(x => {
        arr.push(new Promise((resolve, reject) => {
          insertGoodsPrice(buyer.id, x._goods_id, x._goods_spec_id, x).then(data => {
            x.status = 0;
            resolve(true);
          })
        }))
      })
      const updatePkgArr = rows.filter(x => x.status_pkg === 4);
      updatePkgArr.forEach(x => {
        if (x.pcs_per_carton || x.carton_count_per_pallet) {
          arr.push(new Promise((resolve, reject) => {
            updatePackageSize(buyer.id, x._goods_id, x._goods_spec_id, x).then(data => {
              x.status_pkg = 0;
              resolve(true);
            })
          }))
        }
      })
    }

    Promise.all(arr).then(values1 => {
      Promise.all(arr1).then(values2 => {
        message.success({ content: `同步完成 [ ${values1.length + values2.length}] 条数据 `, key, duration: 1 });
        setRows(temp);
        reload();
        setSyncing(false);
        getGoodsAndPriceList(buyer.id).then(data => setGoodsList(data));
      });
    });
  }

  const initRows = () => {
    rows.forEach((x, i) => {
      if (x[columns[1]]) {
        const name = ((x[columns[1]] + '')+'').trim();
        const pcs_per_carton = isNumeric(x[columns[2]]) ? parseInt(x[columns[2]]) : undefined;
        const carton_count_per_pallet = isNumeric(x[columns[3]]) ? parseInt(x[columns[3]]) : undefined;
        const price = isNumeric(x[columns[4]]) ? parseFloat(x[columns[4]]) : undefined;

        x.idx = i;
        if (name.length === 0) {
          x.status = -1;
        } else {
          x.status = undefined;
        }
        x.name = name;
        x.price = price;
        x.pcs_per_carton = pcs_per_carton;
        x.carton_count_per_pallet = carton_count_per_pallet;
        x.start_time = datetime;
        x.end_time = '2099-12-31 23:59:59';
      } else {
        x.status = -1;
      }
    });
  }
  const checkExistsData = (callback) => {
    if (rows.length === 0) return;
    const arr = [];
    rows.forEach((x, i) => {
      const name = x.name;
      const find = goodsList.find(x => x.goods_spec_name === name);
      if (find) {
        x.status = 0;
        x._goods_id = find.goods_id;
        x._goods_spec_id = find.goods_spec_id;
        x._pcs_per_carton = find.pcs_per_carton;
        x._carton_count_per_pallet = find.carton_count_per_pallet;
        x._price = find.price;
        if (Math.abs(find.price - x.price) > 0.00001) {
          x.status = 3;
        }
        if (find.pcs_per_carton !== x.pcs_per_carton ||
          find.carton_count_per_pallet !== x.carton_count_per_pallet) {
          x.status_pkg = 4;
        }
      } else {
        x.status = 2;
      }
    });
    callback && callback();
  }

  const checkGoodsTable = (callback) => {
    const goods = [];
    const temp = rows.filter(x => x.status === 2);
    temp.forEach(x => {
      if (!goods.find(y => y.name === x.name)) {
        goods.push(x);
      }
    })

    const arr = [];
    const key = 'update_goods';
    goods.forEach(x => {
      const name = x.name;
      arr.push(
        new Promise(async (resolve, reject) => {
          message.loading({ content: `正在校验${name}...`, key });
          try {
            await getGoodsBySpecName(name).then(goodsData => {
              message.loading({ content: `正在校验${name}...`, key });
              x.goods_id = goodsData.goods_id;
              x.goods_spec_id = goodsData.id;
              resolve(true);
            });
          } catch (e) {
            x.status = 1;
            resolve(false);
          }
        })
      );
    })

    Promise.all(arr).then(values => {
      const temp = rows.filter(x => x.status === 2);
      temp.forEach(x => {
        const find = goods.find(y => y.name === x.name);
        if (find) {
          x._goods_id = find.goods_id;
          x._goods_spec_id = find.goods_spec_id;
        }
      })
      callback && callback();
      message.success({ content: `数据校验完成 [ ${values.length}] 条数据  `, key, duration: 1 });
    })
  }


  const checkSupplierDB = async () => {
    setChecking(true);
    initRows();
    checkExistsData(() => {
      checkGoodsTable(() => {
        const temp = [].concat(rows);
        setRows(temp);
        setChecking(false);
      })
    });
  }

  const onExportExcel = () => {
    // 获取表格的dom元素
    var elt = document.getElementById('import-table');
    // 将表格的dom 元素转化为 excel工作薄
    var wb = XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });
    // 将工作薄导出为excel文件
    XLSX.writeFile(wb, '客户产品.xlsx');
  }

  const onImportExcel = file => {
    // 获取上传的文件对象
    const { files } = file.target;
    if (files.length === 0) return;
    setFileName(files[0].name)
    // 通过FileReader对象读取文件
    const fileReader = new FileReader();
    fileReader.onload = event => {
      try {
        const { result } = event.target;
        // 以二进制流方式读取得到整份excel表格对象
        const workbook = XLSX.read(result, { type: 'binary' });
        // 存储获取到的数据
        // 遍历每张工作表进行读取（这里默认只读取第一张表）
        let i = 0;
        let data = [];
        for (const sheet in workbook.Sheets) {
          // esline-disable-next-line
          if (workbook.Sheets.hasOwnProperty(sheet)) {
            // 利用 sheet_to_json 方法将 excel 转成 json 数据
            data = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);
            setBuyerName(sheet);
            break;
          }
        }
        setRows(data);
        // 最终获取到并且格式化后的 json 数据
        message.success('导出文件完成！')
      } catch (e) {
        // 这里可以抛出文件类型错误不正确的相关提示
        message.error('文件类型不正确！');
      }
    };
    // 以二进制方式打开文件
    fileReader.readAsBinaryString(files[0]);
  }

  const parseHeader = () => {
    const tds = [];
    columns.forEach(x => {
      tds.push(<th>{x}</th>);
    })
    return <tr>{tds}</tr>
  }

  const parseRow = (row, ii) => {
    const tds = [];
    columns.forEach((x, i) => {
      if (i === 1) {
        if (row.status === 0) {
          tds.push(<td className="td">{row[x]} <CheckCircleTwoTone twoToneColor="#52c41a" /></td>);
        } else if (row.status === -1) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>无效数据</span></td>);
        } else if (row.status === 1) {
          tds.push(<td className="td">{row[x]} <span style={{ color: '#F50' }}>产品库不存在</span></td>);
        } else if (row.status === 2) {
          tds.push(<td className="td">{row[x]} <span style={{ color: '#FF8C00' }}>客户商库不存在</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else if (i === 2) {
        if (row.status_pkg === 4 && row[x] !== row._pcs_per_carton) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>不一致({row._pcs_per_carton})</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else if (i === 3) {
        if (row.status_pkg === 4 && row[x] !== row._carton_count_per_pallet) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>不一致({row._carton_count_per_pallet})</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else if (i === 4) {
        if (row.status === 3) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>不一致({row._price})</span></td>);
        } else {
          if (row[x] <= 0.00001) {
            tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>无效数据</span></td>);
          } else {
            tds.push(<td className="td">{row[x]}</td>);
          }
        }
      } else {
        tds.push(<td className="td">{row[x]}</td>);
      }
    });
    return <tr>{tds}</tr>
  }

  let isSyncData = rows.filter(x => x.status && x.status > 1 || (x.status_pkg && x.status_pkg > 0)).length > 0;
  return (
    <div className='goods-import-container'>
      <div className="goods-import-button-group">
        <div className='goods-import-file-name'> {fileName} </div>
        <div icon={<UploadOutlined />} className='upload-wrap'>
          <input className='file-uploader' type='file' accept='.xlsx, .xls' onChange={onImportExcel} />
          <span className='upload-text'>选择文件...</span>
        </div>
        <div className='upload-tip'>支持 .xlsx、.xls文件</div>
      </div>
      <div className="goods-import-filter-group">
        {fileName && <div><strong>客户代号：{buyerName}</strong>{buyer.name_nick !== buyerName && <span style={{ color: 'red' }}> [Sheet名和选择客户代码不一致:{buyer.name_nick}]</span>}</div>}
        <div style={{ marginLeft: 'auto' }}></div>
        {
          (rows.length > 0) && <Affix offsetTop={92}>
            <Button icon={<DiffOutlined />} disabled={isSyncing} loading={isChecking} type="primary" onClick={() => checkSupplierDB()}>
              数据比对
            </Button>
            <Button loading={isSyncing} disabled={isChecking || !isSyncData} icon={<SyncOutlined />} type="primary" onClick={() => syncSupplierDB()}>
              数据库同步
            </Button>
            {fileName && <Button onClick={onExportExcel}>导出到Excel...</Button>}
          </Affix>
        }
      </div>
      <div className="goods-import-content">
        <table id="import-table" border="1" className="goods_table">
          {
            rows.length > 0 && parseHeader(rows[0])
          }
          {
            rows.map((x, i) => {
              return parseRow(x, i)
            })
          }
        </table>
      </div>
    </div >
  );
});